function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-free-code\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.34,30.22a1.12,1.12,0,0,1-.79-.33L4.62,23a3.68,3.68,0,0,1,0-5.18l6.93-6.92a1.12,1.12,0,1,1,1.59,1.59L6.22,19.39a1.41,1.41,0,0,0,0,2l6.92,6.92a1.13,1.13,0,0,1-.8,1.92Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.66,30.22a1.13,1.13,0,0,1-.8-1.92l6.92-6.92a1.41,1.41,0,0,0,0-2l-6.92-6.93a1.12,1.12,0,0,1,1.59-1.59l6.93,6.92a3.68,3.68,0,0,1,0,5.18l-6.93,6.92A1.12,1.12,0,0,1,27.66,30.22Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.79,35.85a1.14,1.14,0,0,1-1.08-1.44l8.42-29A1.12,1.12,0,1,1,25.29,6L16.87,35A1.12,1.12,0,0,1,15.79,35.85Z",
  fill: "#231f20"
});

function SvgCmsFreeCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgCmsFreeCode;